{
  "upload": {
    "absent": {
      "text": "You do not have an active license."
    },
    "text": "Upload your license file",
    "title": "Click here to select and upload a license file",
    "dropInformation": "Deposit the license here or click here to start the selection",
    "validation": {
      "fileMandatory": "File must be a .JWT or .OPL",
      "fileEmpty": "The file must not be empty",
      "fileSize": "The file must be less than 750MB in size"
    },
    "new": {
      "text": "Upload a new license file",
      "title": "Click here to select and upload a new license file"
    },
    "loading": "Loading...",
    "success": "Valid license",
    "errors": {
      "signature_invalid": "A signing error with the licence file has been detected.",
      "license_id_already_exists": "The license identifier is the same as the current license.",
      "platform_id_not_match": "The platform identifier does not match.",
      "organization_id_not_match": "The organization identifier does not match.",
      "expires_contracted_invalid": "The expiration date is lower than the current date.",
      "expires_tolerate_invalid": "The expiration date does not match the expected value.",
      "max_devices_total_value_invalid": "The total number of devices does not match the expected value.",
      "max_devices_total_contracted_expires_invalid": "The number of devices is lower than the current value for the organization.",
      "max_devices_total_tolerated_expires_invalid": "The total number of devices does not match the expected value.",
      "max_devices_by_type_value_invalid": "The total number of devices does not match the expected value.",
      "max_devices_by_type_contracted_expires_invalid": "The number of devices is lower than the current value for the organization.",
      "max_devices_by_type_tolerated_expires_invalid": "The total number of devices does not match the expected value.",
      "feature_value_invalid": "The licence features do not match the expected value.",
      "schema_not_match": "A format error of the licence file has been detected regarding the following information: {field}"
    }
  },
  "status": {
    "title": "License status",
    "active": "Active",
    "notActive": "Stand by",
    "warning": "Warning",
    "expired": "Expired"
  },
  "characteristics": {
    "title": "Characteristics",
    "date": {
      "validated": "Validation date:",
      "validatedOn": "Validated on {date}",
      "start": "Start date:",
      "end": "Expiration date:"
    },
    "id": "License Id:"
  },
  "idCard": {
    "title": "Information needed to obtain a license",
    "description": "These identifiers are useful for generating the licences.",
    "export": {
      "title": "Export ID card",
      "text": "Export ID card"
    },
    "download": "Download ID card"
  },
  "overlay": {
    "title": {
      "notFound": "Your organization requires a license",
      "expired": "Your license has expired"
    },
    "message": {
      "notFound": "To operate your organization, please upload a license. Access will be blocked as long as a valid license has been uploaded.",
      "expired": "To continue operating your organization, please renew your license. Access is temporarly blocked until situation is resolved."
    }
  },
  "gauge": {
    "device": {
      "warning": {
        "tooltip": "You have reached the number of authorized devices by your license",
        "message": "Threshold reached"
      },
      "error": {
        "tooltip": "No additionnal device can be provisionned on the platform",
        "message": "Limit reached"
      }
    }
  },
  "deviceTypes": {
    "title": "Device thresholds"
  },
  "withoutLimits": "Without limit",
  "total": "Total",
  "features": {
    "title": "License limits",
    "interfaces_third_party": "Interfaces",
    "warning": {
      "tooltip": "You have exceeded your license limit"
    },
    "error": {
      "tooltip": "The creation of new resources is disabled"
    }
  },
  "warning": {
    "title": "License limit reached.",
    "expirationDateExceeded": "You have exceeded your license expiration date. Please renew your license before service interruption.",
    "devicesCountExceeded": "You have exceeded the allowed number of devices with your current license. Some functionalities may be limited until the issue is resolved.",
    "redirect": "View license panel"
  }
}
